module.exports = __webpack_public_path__ + "static/media/offices (3).6a06a687.webp";